import { CustomFieldConditionEnum } from 'src/ajs-app/components/parameters/quick-replies/joint-diagram/conditions-on-custom-fields/custom-field-condition.enum.js';
import { SegmentCondition } from './segments.model';

SegmentEditionController.$inject = ['$scope', '$mdDialog', 'segment', 'dropdownItems'];
export function SegmentEditionController($scope, $mdDialog, segment, dropdownItems) {

  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.addCondition = addCondition;
  $scope.removeCondition = removeCondition;
  $scope.segmentConditionOnCustomFieldChanged = segmentConditionOnCustomFieldChanged;


  init();

  function ok() {
    $mdDialog.hide($scope.segment);
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function addCondition() {
    $scope.segment.conditions.push(new SegmentCondition());
  }

  function removeCondition(index) {
    $scope.segment.conditions.splice(index, 1);
  }

  function init() {
    $scope.segment = segment;
    $scope.dropdownItems = dropdownItems;
  }

  function segmentConditionOnCustomFieldChanged() {
    $scope.hasInvalidConditionOnCustomField = ($scope.segment.conditions || []).some(condition => {
      if (!condition.isTypeConditionOnCustomField()) {
        return false;
      }

      const { selectedCustomField, selectedCondition, comparedValue } = condition.parameters;
      const invalidComparedValue = selectedCondition !== CustomFieldConditionEnum.IS_NOT_NULL && selectedCondition !== CustomFieldConditionEnum.IS_NULL && (comparedValue === null || comparedValue === '');
      return !selectedCustomField || !selectedCondition || invalidComparedValue;
    })

  }

}
